import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ShieldAlert, Home } from "lucide-react";

export default function Forbidden() {
  return (
    <>
      <Helmet>
        <title>Adgang nægtet - Henneberg Byggeri ApS</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <section className="min-h-[70vh] flex items-center justify-center bg-white text-neutral-900 px-4">
        <div className="max-w-md w-full text-center space-y-6">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-100 text-red-600">
            <ShieldAlert className="h-8 w-8" />
          </div>
          <div className="space-y-2">
            <h1 className="text-4xl font-extrabold tracking-tight text-neutral-900 sm:text-5xl">
              403
            </h1>
            <h2 className="text-xl font-bold text-neutral-800">
              Adgang nægtet
            </h2>
            <p className="text-sm text-gray-500 leading-relaxed max-w-sm mx-auto">
              Du har ikke tilladelse til at tilgå denne side. Hvis du mener, at dette er en fejl, bedes du kontakte os.
            </p>
          </div>
          <div>
            <Link
              to="/"
              className="inline-flex items-center gap-2 rounded bg-[#434359] px-6 py-3 text-sm font-bold uppercase tracking-wider text-white transition-colors hover:bg-[#343446]"
            >
              <Home className="h-4 w-4" />
              Tilbage til forsiden
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
